<div class="rd-widget" [style.height.px]="widgetHeight" *ngIf="signatureAndLicenseService.choices$ | async as choices">
  <table class="widget-flex" aria-hidden="true" *ngIf="widgetData">
    <thead>
      <dynamic-growth-row [row]="1" [widget]="this">
        <tr class="widget-ruller-flex">
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
        </tr>
      </dynamic-growth-row>
    </thead>

    <tbody>
      <dynamic-growth-row [row]="2" [widget]="this">
        <tr [hidden]="!editMode" *ngIf="!rdStorage.getAppPrintMode()">
          <td colspan="16" class="widgetImageTypePlaceholder">
            <table class="valuerSelection" aria-hidden="true">
              <dynamic-growth-row [row]="3" [widget]="this">
                <tr>
                  <td class="align-left">Valuer</td>
                  <td>
                    <kendo-dropdownlist [disabled]="signatureAndLicenseService.isDisabledUsers[currentLayoutIndex]"
                                        [data]="signatureAndLicenseService.dataUsers[currentLayoutIndex]"
                                        [value]="signatureAndLicenseService.selectedUser[currentLayoutIndex]"
                                        textField="userName"
                                        valueField="userId"
                                        (valueChange)="signatureAndLicenseService.handleUserChange(currentLayoutIndex, $event); setDirtyFlag(true, true);">
                    </kendo-dropdownlist>
                  </td>
                </tr>
              </dynamic-growth-row>
              <dynamic-growth-row [row]="4" [widget]="this">
                <tr>
                  <td class="align-left">License</td>
                  <td>
                    <kendo-dropdownlist [disabled]="signatureAndLicenseService.isDisabledLicenses[currentLayoutIndex]"
                                        [data]="signatureAndLicenseService.dataResultLicenses[currentLayoutIndex]"
                                        [value]="signatureAndLicenseService.selectedLicense[currentLayoutIndex]"
                                        textField="licenseName"
                                        valueField="licenseName"
                                        (valueChange)="signatureAndLicenseService.handleLicenseChange(currentLayoutIndex, $event); setDirtyFlag(true, true);">
                    </kendo-dropdownlist>
                  </td>
                </tr>
              </dynamic-growth-row>
            </table>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="5" [widget]="this">
        <tr [hidden]="editMode">
          <td class="widgetImagePlaceholder" colspan="16"
              [ngStyle]="{ 'background': 'url(' + widgetData[currentLayoutIndex].signature + ')'}">
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="6" [widget]="this">
        <tr [hidden]="editMode" class="userData">
          <td colspan="16" class="line">
            {{widgetData[currentLayoutIndex].first_name}} {{widgetData[currentLayoutIndex].last_name}}<span *ngIf="widgetData.suffix">, {{widgetData[currentLayoutIndex].suffix}}</span>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="7" [widget]="this">
        <tr [hidden]="editMode" class="userData">
          <td colspan="16">
            {{widgetData[currentLayoutIndex].title}}
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="8" [widget]="this">
        <tr [hidden]="editMode" class="userData">
          <td colspan="16">
            {{widgetData[currentLayoutIndex].certification_level}}
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="9" [widget]="this">
        <tr [hidden]="editMode" class="userData">
          <td colspan="16">
            <span *ngIf="getLicenseNo(widgetData)">Certificate Number: {{getLicenseNo(widgetData[currentLayoutIndex])}}</span>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="10" [widget]="this">
        <tr [hidden]="editMode" class="userData">
          <td colspan="16">
            {{widgetData[currentLayoutIndex].email}}
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="11" [widget]="this">
        <tr [hidden]="editMode" class="userData">
          <td colspan="16">
            {{widgetData[currentLayoutIndex].phone}}
          </td>
        </tr>
      </dynamic-growth-row>
    </tbody>
  </table>
</div>

